import { initGameDetailsNoteDelete } from './game-details-notes/note-delete.js';
import { initGameDetailsNoteEdit } from './game-details-notes/note-edit.js';
import { initGameDetailsNoteForm } from './game-details-notes/note-form.js';
import { initGameDetailsNotesStreamController } from './game-details-notes/stream-controller.js';

export function initGameDetailsNotes(documentRef = document, fetchImpl = fetch) {
    if (initGameDetailsNoteForm(documentRef) === null) {
        return null;
    }
    initGameDetailsNoteEdit(documentRef);
    initGameDetailsNoteDelete(documentRef);

    return initGameDetailsNotesStreamController(documentRef, fetchImpl);
}

initGameDetailsNotes();
